import { render, staticRenderFns } from "./lead-list.vue?vue&type=template&id=764a6a2e&scoped=true&"
import script from "./lead-list.vue?vue&type=script&lang=js&"
export * from "./lead-list.vue?vue&type=script&lang=js&"
import style0 from "./lead-list.vue?vue&type=style&index=0&id=764a6a2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764a6a2e",
  null
  
)

export default component.exports